import {Entities, IAccountEntity, INotificationEntity} from '../entities';
import {IVendorListEntity, IVendorListItemEntity} from '../VendorList';
import {IProjectEntity} from '../Project';

export namespace GcCertify {
  export type Entity = {
    notificationId: number;
    notification: INotificationEntity;
    projectId: number;
    project: IProjectEntity;
    listId: number;
    list: IVendorListEntity;
    certificationItems: ItemEntity[];
    requestedById: number;
    requestedBy: IAccountEntity;
    requiredFinish?: string;
    vendorSeenOn?: string;
    seenByVendor?: IAccountEntity;
    seenByVendorId?: number;
    completedOn?: string;
    completedById?: number;
    completedBy?: IAccountEntity;
    isCertified: boolean;
    comment?: string;
  } & Entities.BaseEntity;

  export type ItemEntity = {
    gcCertification: Entity;
    gcCertificationId: number;
    classificationIds?: number[];
    listItem?: Promise<IVendorListItemEntity>;
    listItemId?: number;
    name?: string;
    dirRegNo?: string;
    action: Actions;
    comment?: string;
  } & Entities.BaseEntity;

  export enum Actions {
    Add = 'add',
    Remove = 'remove',
    Update = 'update',
    None = 'none'
  }

  export namespace Notification {
    export type RequestData = {
      projectId: number;
      listId: number;
    }

    export type ResponseData = {
      assignmentId: number;
      vendorName: string;
      dirNo: string;
      licNo?: string;
      action: Actions;
      comment?: string;
    }
  }

  export namespace API {
    export type Endpoint = 'gcCertify';

    export type CreateCertificationResponse = {
      hasExisting: boolean;
      data: {
        id: number;
        notificationId: number;
      }
    }

    export type GetCertificationResponse = {
      certificationItems: ItemEntity[];
      comment?: string;
      completedBy?: IAccountEntity;
      completedById?: number;
      completedOn?: string;
      isCertified: boolean;
      list: IVendorListEntity;
      listId: number;
      notification: INotificationEntity;
      notificationId: number;
      project: IProjectEntity;
      projectId: number;
      requestedBy: IAccountEntity;
      requestedById: number;
      requiredFinish?: string;
      seenByVendor?: IAccountEntity;
      seenByVendorId?: number;
      vendorSeenOn?: string;
      updated: string;
    } & Omit<Entities.BaseEntity,'updated'>;

    export type CertificationUpdateData = {
      id: number;
      isComplete: boolean;
      isCertified: boolean;
      comments?: string;
      actions: CertificationItemData[];
    }

    export type CertificationItemData = {
      action: Actions;
      id?: number;
      gcCertificationId: number;
      listItemId?: number;
      dirRegNo?: string; // create only...
      name?: string; // vendor name
      classificationIds?: number[];
      comment?: string;
    }
  }

}